import { render, staticRenderFns } from "./AdmFeeForm.vue?vue&type=template&id=bc51e9f4&"
import script from "./AdmFeeForm.vue?vue&type=script&lang=js&"
export * from "./AdmFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports